'use strict';

var toPathComponents = function toPathComponents() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // split on / unless escaped with \
  return (path.trim().match(/([^\\^/]|\\\/)+/g) || []).filter(Boolean);
};

module.exports = toPathComponents;